import { Message, messageBannerFunctions, MessageTypes } from '@nhl/nhl-react-ui/lib/MessageBanner';

import ValidationError from 'media-base-ui/utils/ValidationError';
import { updatePassword } from 'media-base-ui/utils/accountAPI';

import actionCreators from './actionCreators';

const changeValue = actionCreators.changeValue;

const savePassword = (passwordData, isReset, validationCode) => async dispatch => {
    dispatch(actionCreators.requestSave());

    try {
        await updatePassword({
            passwordData,
            isReset,
            validationCode
        });

        dispatch(actionCreators.saveResponse(true, []));
        messageBannerFunctions.dispatchMessage(new Message('Password updated successfully!',
            MessageTypes.SUCCESS));
    } catch (errors) {
        if (errors[0] instanceof ValidationError) {
            dispatch(actionCreators.saveResponse(false, errors));
            messageBannerFunctions.dispatchMessage(new Message('There were some problems with the form. See below for more details.',
                MessageTypes.ERROR));
        } else {
            dispatch(actionCreators.saveResponse(false, []));
            errors.response.json().then(body => {
                if (errors.response.status === 401) {
                    messageBannerFunctions.dispatchMessage(new Message('The current password does not match our records. Please correct it below.',
                        MessageTypes.ERROR));
                } else if (body.message.indexOf('Invalid or expired' >= 0)) {
                    messageBannerFunctions.dispatchMessage(new Message('The validation code specified is invalid or expired. Please follow the link ' +
                        'from the email that was sent to you or submit a new Forgot Password request.',
                        MessageTypes.ERROR));
                } else {
                    messageBannerFunctions.dispatchMessage(new Message('We\'re having a problem on our end. Please try again later.',
                        MessageTypes.ERROR));
                }
            });
        }
    }
};

export default {
    changeValue,
    savePassword
};